import { Component, Input } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { cloneDeep } from "lodash-es";
import { InputMask, MaskedPattern } from "imask";

@Component({
    selector: "vui-masked-form-field",
    templateUrl: "./masked-form-field.component.html",
})
export class MaskedFormFieldComponent {
    @Input()
    matDense: boolean = false;

    @Input()
    label: string;

    @Input()
    placeholder: string;

    @Input()
    form: FormGroup;

    @Input()
    controlName: string;

    _mask: InputMask<any> | MaskedPattern<any>;

    @Input()
    set mask(mask) {
        this._mask = cloneDeep(mask);
    }

    get mask() {
        return this._mask;
    }

    @Input()
    unmask: boolean = true;

    constructor() {}

    onAccept(maskRef: InputMask<any>): void {
        const control = this.form.get(this.controlName) as FormControl;
        if (!control) return;

        if (maskRef.masked.isComplete) {
            control.setErrors(null);
        } else {
            if (control.errors?.["required"]) {
                control.setErrors({ required: true });
            } else {
                control.setErrors({ invalid: true });
            }
        }
    }

    onComplete(maskRef: InputMask<any>): void {
        const control = this.form.get(this.controlName) as FormControl;
        if (!control) return;

        control.setErrors(null);
    }
}
